webpackJsonp([6],{

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(242);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(167)("e7832690", content, true);

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(166)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Avatar.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leancloud_storage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leancloud_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_leancloud_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AvatarCrop_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AvatarCrop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AvatarCrop_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      percent: 0,
      btnVisible: false,
      rts: null,
      currentAvatar: this.$store.getters.user.avatar,
      base64: ''
    };
  },

  components: {
    AvatarCrop: __WEBPACK_IMPORTED_MODULE_3__components_AvatarCrop_vue___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['updateUser']), {
    onAvatarChange: function onAvatarChange(base64) {
      this.btnVisible = true;
      this.base64 = base64;
    },
    upload: function upload() {
      var _this = this;

      var file = new __WEBPACK_IMPORTED_MODULE_1_leancloud_storage___default.a.File('avatar.jpg', { base64: this.base64 });
      file.save({
        onprogress: function onprogress(e) {
          _this.percent = e.percent;
        }
      }).then(function (data) {
        _this.$toast('头像已上传');
        var url = data.url();
        _this.updateUser({ avatar: url });
        return __WEBPACK_IMPORTED_MODULE_1_leancloud_storage___default.a.User.current().set('avatar', url).save();
      }).catch(function (error) {
        _this.$toast('头像上传失败，请稍后重试');
        console.error(error);
      }).then(function () {
        _this.$router.go(-1);
      });
    }
  })
});

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(248),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a5f6208",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(246);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(167)("18a4456e", content, true);

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(166)(true);
// imports


// module
exports.push([module.i, ".avatar-crop[data-v-5a5f6208]{margin:2.13333rem auto;padding:.26667rem;border:2px solid #f3c0c0;text-align:center;border-radius:4px}.avatar-crop .wrapper[data-v-5a5f6208]{position:relative;width:4.8rem;height:4.8rem}.avatar-crop .tips[data-v-5a5f6208]{position:absolute;bottom:-1.06667rem}.avatar-crop .image[data-v-5a5f6208],.avatar-crop .upload[data-v-5a5f6208]{position:absolute;left:0;top:0;width:100%;height:100%}.avatar-crop .image[data-v-5a5f6208]{background-size:cover;background-position:50%}.avatar-crop .upload[data-v-5a5f6208]{opacity:0}.avatar-crop .crop[data-v-5a5f6208]{position:fixed;left:0;top:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);-webkit-transition:opacity .5s ease;transition:opacity .5s ease;z-index:10}.avatar-crop .loading[data-v-5a5f6208]{display:none}.avatar-crop .dialog[data-v-5a5f6208]{position:relative;background-color:#fafafc;border-radius:4px;-webkit-transition:all .5s ease;transition:all .5s ease}.avatar-crop .dialog>section[data-v-5a5f6208]{position:relative;overflow:hidden}.avatar-crop .dialog .grab[data-v-5a5f6208]{cursor:grab;cursor:grabbing}.avatar-crop .dialog img[data-v-5a5f6208]{position:absolute;max-width:none}.avatar-crop .dialog .btn[data-v-5a5f6208]{height:1.28rem;line-height:1.28rem;text-align:center;color:#5f7b88;font-size:16px;border:none;background-color:transparent}.avatar-crop .dialog .scale[data-v-5a5f6208]{-webkit-appearance:none;position:absolute;left:12.5%;bottom:2.34667rem;width:75%;border:none;outline:none;cursor:pointer}.avatar-crop .dialog .scale[data-v-5a5f6208]::-webkit-slider-runnable-track{width:100%;height:.05333rem;cursor:pointer;background:#efb708}.avatar-crop .dialog .scale[data-v-5a5f6208]::-webkit-slider-thumb{height:.53333rem;width:.53333rem;border-radius:10px;background:#fff;border:2px solid #efb708;cursor:pointer;-webkit-appearance:none;margin-top:-.26667rem}.avatar-crop .dialog .scale[data-v-5a5f6208]::-moz-range-track{width:100%;height:.05333rem;cursor:pointer;background:#efb708}.avatar-crop .dialog .scale[data-v-5a5f6208]::-moz-range-thumb{height:.42667rem;width:.42667rem;border-radius:8px;border:2px solid #efb708;background:#fff;cursor:pointer}.avatar-crop .dialog .scale[data-v-5a5f6208]::-ms-track{width:100%;height:.02667rem;cursor:pointer;background:transparent;border-color:transparent;color:transparent}.avatar-crop .dialog .scale[data-v-5a5f6208]::-ms-fill-lower,.avatar-crop .dialog .scale[data-v-5a5f6208]::-ms-fill-upper{background:rgba(0,0,0,.5);border:0 solid hsla(0,0%,78%,.2);border-radius:0;box-shadow:0 0 0 transparent,0 0 0 hsla(0,0%,5%,0)}.avatar-crop .dialog .scale[data-v-5a5f6208]::-ms-thumb{height:.42667rem;width:.42667rem;border-radius:8px;background:#fff;cursor:pointer;height:.02667rem}.avatar-crop .dialog .scale[data-v-5a5f6208]:focus::-ms-fill-lower,.avatar-crop .dialog .scale[data-v-5a5f6208]:focus::-ms-fill-upper{background:rgba(0,0,0,.5)}", "", {"version":3,"sources":["/opt/build/repo/src/components/AvatarCrop.vue"],"names":[],"mappings":"AACA,8BACE,uBAAwB,AACxB,kBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,iBAAmB,CACpB,AACD,uCACE,kBAAmB,AACnB,aAAc,AACd,aAAe,CAChB,AACD,oCACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,2EAEE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,WAAa,CACd,AACD,qCACE,sBAAuB,AACvB,uBAAmC,CACpC,AACD,sCACE,SAAW,CACZ,AACD,oCACE,eAAgB,AAChB,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,gCAAkC,AAClC,oCAAsC,AACtC,4BAA8B,AAC9B,UAAY,CACb,AACD,uCACE,YAAc,CACf,AACD,sCACE,kBAAmB,AACnB,yBAA0B,AAC1B,kBAAmB,AACnB,gCAAkC,AAClC,uBAA0B,CAC3B,AACD,8CACE,kBAAmB,AACnB,eAAiB,CAClB,AACD,4CACE,YAAa,AAGb,eAAiB,CAFlB,AAID,0CACE,kBAAmB,AACnB,cAAgB,CACjB,AACD,2CACE,eAAgB,AAChB,oBAAqB,AACrB,kBAAmB,AACnB,cAAe,AACf,eAAgB,AAChB,YAAa,AACb,4BAA8B,CAC/B,AACD,6CACE,wBAAyB,AACzB,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,UAAW,AACX,YAAa,AACb,aAAc,AACd,cAAgB,CACjB,AACD,4EACE,WAAY,AACZ,iBAAmB,AACnB,eAAgB,AAChB,kBAAoB,CACrB,AACD,mEACE,iBAAmB,AACnB,gBAAkB,AAClB,mBAAoB,AACpB,gBAAiB,AACjB,yBAA0B,AAC1B,eAAgB,AAChB,wBAAyB,AACzB,qBAAwB,CACzB,AACD,+DACE,WAAY,AACZ,iBAAmB,AACnB,eAAgB,AAChB,kBAAoB,CACrB,AACD,+DACE,iBAAmB,AACnB,gBAAkB,AAClB,kBAAmB,AACnB,yBAA0B,AAC1B,gBAAiB,AACjB,cAAgB,CACjB,AACD,wDACE,WAAY,AACZ,iBAAmB,AACnB,eAAgB,AAChB,uBAAwB,AACxB,yBAA0B,AAC1B,iBAAmB,CACpB,AAOD,0HACE,0BAA4B,AAC5B,iCAAwC,AACxC,gBAAmB,AACnB,kDAA0E,CAC3E,AACD,wDACE,iBAAmB,AACnB,gBAAkB,AAClB,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,gBAAmB,CACpB,AAID,sIACE,yBAA4B,CAC7B","file":"AvatarCrop.vue","sourcesContent":["\n.avatar-crop[data-v-5a5f6208] {\n  margin: 2.13333rem auto;\n  padding: 0.26667rem;\n  border: 2px solid #f3c0c0;\n  text-align: center;\n  border-radius: 4px;\n}\n.avatar-crop .wrapper[data-v-5a5f6208] {\n  position: relative;\n  width: 4.8rem;\n  height: 4.8rem;\n}\n.avatar-crop .tips[data-v-5a5f6208] {\n  position: absolute;\n  bottom: -1.06667rem;\n}\n.avatar-crop .image[data-v-5a5f6208],\n.avatar-crop .upload[data-v-5a5f6208] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n}\n.avatar-crop .image[data-v-5a5f6208] {\n  background-size: cover;\n  background-position: center center;\n}\n.avatar-crop .upload[data-v-5a5f6208] {\n  opacity: 0;\n}\n.avatar-crop .crop[data-v-5a5f6208] {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,0.7);\n  -webkit-transition: opacity 0.5s ease;\n  transition: opacity 0.5s ease;\n  z-index: 10;\n}\n.avatar-crop .loading[data-v-5a5f6208] {\n  display: none;\n}\n.avatar-crop .dialog[data-v-5a5f6208] {\n  position: relative;\n  background-color: #fafafc;\n  border-radius: 4px;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n.avatar-crop .dialog > section[data-v-5a5f6208] {\n  position: relative;\n  overflow: hidden;\n}\n.avatar-crop .dialog .grab[data-v-5a5f6208] {\n  cursor: grab;\n}\n.avatar-crop .dialog .grab[data-v-5a5f6208] {\n  cursor: grabbing;\n}\n.avatar-crop .dialog img[data-v-5a5f6208] {\n  position: absolute;\n  max-width: none;\n}\n.avatar-crop .dialog .btn[data-v-5a5f6208] {\n  height: 1.28rem;\n  line-height: 1.28rem;\n  text-align: center;\n  color: #5f7b88;\n  font-size: 16px;\n  border: none;\n  background-color: transparent;\n}\n.avatar-crop .dialog .scale[data-v-5a5f6208] {\n  -webkit-appearance: none;\n  position: absolute;\n  left: 12.5%;\n  bottom: 2.34667rem;\n  width: 75%;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n.avatar-crop .dialog .scale[data-v-5a5f6208]::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.05333rem;\n  cursor: pointer;\n  background: #efb708;\n}\n.avatar-crop .dialog .scale[data-v-5a5f6208]::-webkit-slider-thumb {\n  height: 0.53333rem;\n  width: 0.53333rem;\n  border-radius: 10px;\n  background: #fff;\n  border: 2px solid #efb708;\n  cursor: pointer;\n  -webkit-appearance: none;\n  margin-top: -0.26667rem;\n}\n.avatar-crop .dialog .scale[data-v-5a5f6208]::-moz-range-track {\n  width: 100%;\n  height: 0.05333rem;\n  cursor: pointer;\n  background: #efb708;\n}\n.avatar-crop .dialog .scale[data-v-5a5f6208]::-moz-range-thumb {\n  height: 0.42667rem;\n  width: 0.42667rem;\n  border-radius: 8px;\n  border: 2px solid #efb708;\n  background: #fff;\n  cursor: pointer;\n}\n.avatar-crop .dialog .scale[data-v-5a5f6208]::-ms-track {\n  width: 100%;\n  height: 0.02667rem;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n.avatar-crop .dialog .scale[data-v-5a5f6208]::-ms-fill-lower {\n  background: rgba(0,0,0,0.5);\n  border: 0px solid rgba(200,200,200,0.2);\n  border-radius: 0px;\n  box-shadow: 0rem 0rem 0rem rgba(0,0,0,0), 0rem 0rem 0rem rgba(13,13,13,0);\n}\n.avatar-crop .dialog .scale[data-v-5a5f6208]::-ms-fill-upper {\n  background: rgba(0,0,0,0.5);\n  border: 0px solid rgba(200,200,200,0.2);\n  border-radius: 0px;\n  box-shadow: 0rem 0rem 0rem rgba(0,0,0,0), 0rem 0rem 0rem rgba(13,13,13,0);\n}\n.avatar-crop .dialog .scale[data-v-5a5f6208]::-ms-thumb {\n  height: 0.42667rem;\n  width: 0.42667rem;\n  border-radius: 8px;\n  background: #fff;\n  cursor: pointer;\n  height: 0.02667rem;\n}\n.avatar-crop .dialog .scale[data-v-5a5f6208]:focus::-ms-fill-lower {\n  background: rgba(0,0,0,0.5);\n}\n.avatar-crop .dialog .scale[data-v-5a5f6208]:focus::-ms-fill-upper {\n  background: rgba(0,0,0,0.5);\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    defaultImage: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: 'image/jpg,image/jpeg,image/png,image/gif'
    },
    quality: {
      type: Number,
      default: 0.8
    },
    showCircle: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    okText: {
      type: String,
      default: '确定'
    },
    width: {
      type: Number,
      default: 320
    },
    height: {
      type: Number,
      default: 320
    },
    returnBase64: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showCropDialog: false,
      selectedFile: null,

      croppedImage: null,
      img: null,
      scale: 100,
      scaleX: 0,
      scaleY: 0,
      scaleLength: 0,
      scaleWidth: 0,
      scaleHeight: 0,
      drag: false,
      grabbing: false,
      beginX: 0,
      beginY: 0,
      beginLength: 0,
      canvas: null,
      context: null
    };
  },

  methods: {
    fileChange: function fileChange(e) {
      var _this = this;

      if (e.target.files.length === 0) {
        return false;
      }
      this.selectedFile = e.target.files[0];
      this.showCropDialog = true;

      var fr = new window.FileReader();
      fr.readAsDataURL(this.selectedFile);
      fr.onload = function (e) {
        _this.img = new window.Image();
        _this.img.src = fr.result;
        _this.img.onload = function () {
          if (_this.img.naturalWidth > _this.img.naturalHeight) {
            _this.scaleHeight = _this.height;
            _this.scaleWidth = Math.round(_this.scaleHeight * _this.img.naturalWidth / _this.img.naturalHeight);
          } else {
            _this.scaleWidth = _this.width;
            _this.scaleHeight = Math.round(_this.scaleWidth * _this.img.naturalHeight / _this.img.naturalWidth);
          }
          _this.scaleX = -Math.round((_this.scaleWidth - _this.width) / 2);
          _this.scaleY = -Math.round((_this.scaleHeight - _this.height) / 2);

          _this.canvas = document.createElement('canvas');
          _this.canvas.width = _this.width;
          _this.canvas.height = _this.height;
          _this.canvas.setAttribute('style', 'position:absolute;left:0;top:0;opacity:0;z-index:-1');
          _this.context = _this.canvas.getContext('2d');
          _this.cropToCanvas();
          document.body.appendChild(_this.canvas);
        };
      };
    },
    cropDragBegin: function cropDragBegin(e) {
      this.drag = true;
      this.grabbing = true;
      this.beginX = e.touches[0].pageX - e.target.offsetLeft;
      this.beginY = e.touches[0].pageY - e.target.offsetTop;
      if (e.touches.length === 2) {
        this.beginLength = this.beginLength === 0 ? this.cropTouchData(e).length : this.beginLength;
      }
    },
    cropDragMove: function cropDragMove(e) {
      if (!this.drag) {
        return false;
      }

      if (e.touches.length === 2) {
        this.scaleLength = this.cropTouchData(e).length;
        this.scale = Math.min(200, Math.max(100, this.scaleLength / this.beginLength * 100));
        this.cropZoom();
      } else {
        this.scaleX = e.changedTouches[0].pageX - this.beginX;
        this.scaleY = e.changedTouches[0].pageY - this.beginY;
      }
      this.cropLimit();
    },
    cropDragEnd: function cropDragEnd(e) {
      this.drag = false;
      this.grabbing = false;
      this.cropToCanvas();
    },
    cropToCanvas: function cropToCanvas() {
      this.context.clearRect(0, 0, this.width, this.height);

      var sx = Math.round(Math.abs(this.scaleX) * this.img.naturalWidth / this.scaleWidth);

      var sy = Math.round(Math.abs(this.scaleY) * this.img.naturalHeight / this.scaleHeight);
      var sw = this.width * this.img.naturalWidth / this.scaleWidth;
      var sh = this.height * this.img.naturalHeight / this.scaleHeight;

      this.context.fillStyle = '#FFFFFF';
      this.context.fillRect(0, 0, this.width, this.height);
      this.context.drawImage(this.img, sx, sy, sw, sh, 0, 0, this.width, this.height / this.cropGetRatio());
    },
    cropZoom: function cropZoom() {
      var s = this.scale / 100;

      if (this.img.naturalWidth > this.img.naturalHeight) {
        this.scaleHeight = this.height * s;
        this.scaleWidth = this.scaleHeight * this.img.naturalWidth / this.img.naturalHeight;
      } else {
        this.scaleWidth = this.width * s;
        this.scaleHeight = this.scaleWidth * this.img.naturalHeight / this.img.naturalWidth;
      }
      this.scaleX = -(this.scaleWidth - this.width) / 2;
      this.scaleY = -(this.scaleHeight - this.width) / 2;
      this.cropLimit();
      this.cropToCanvas();
    },
    cropTouchData: function cropTouchData(e) {
      if (e.touches.length < 2) {
        return;
      }
      var x1 = e.touches[0].pageX;
      var x2 = e.touches[1].pageX;
      var x3 = x1 <= x2 ? (x2 - x1) / 2 + x1 : (x1 - x2) / 2 + x2;
      var y1 = e.touches[0].pageY - this.scrollbar.scrollTop;
      var y2 = e.touches[1].pageY - this.scrollbar.scrollTop;
      var y3 = y1 <= y2 ? (y2 - y1) / 2 + y1 : (y1 - y2) / 2 + y2;
      return {
        length: Math.round(Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2))),
        x: Math.round(x3),
        y: Math.round(y3)
      };
    },
    cropLimit: function cropLimit() {
      if (this.scaleX < -(this.scaleWidth - this.width)) {
        this.scaleX = -(this.scaleWidth - this.width);
      }
      if (this.scaleY < -(this.scaleHeight - this.height)) {
        this.scaleY = -(this.scaleHeight - this.height);
      }
      if (this.scaleX > 0) {
        this.scaleX = 0;
      }
      if (this.scaleY > 0) {
        this.scaleY = 0;
      }
      if (this.scaleHeight === this.height) {
        this.scaleY = 0;
      }
      if (this.scaleWidth === this.width) {
        this.scaleX = 0;
      }
    },
    cropOK: function cropOK() {
      var data = this.canvas.toDataURL('image/jpeg', this.quality || 0.8);
      this.croppedImage = data;
      if (this.returnBase64) {
        this.$emit('change', data);
      } else {
        var _data = window.atob(data.split(',')[1]);
        var aBuffer = new ArrayBuffer(_data.length);
        var uBuffer = new Uint8Array(aBuffer);
        for (var i = 0; i < data.length; i++) {
          uBuffer[i] = data.charCodeAt(i);
        }
        var blob = new window.Blob([uBuffer], { type: 'image/jpeg' });
        this.$emit('change', blob);
      }
      this.cropCancel();
    },
    cropCancel: function cropCancel() {
      this.showCropDialog = false;
      this.scale = 100;
      this.scaleX = 0;
      this.scaleY = 0;
      this.scaleLength = 0;
      this.scaleWidth = 0;
      this.scaleHeight = 0;
      this.beginX = 0;
      this.beginY = 0;
      this.beginLength = 0;
      this.canvas = null;
      this.context = null;
      if (this.canvas) {
        document.body.removeChild(this.canvas);
      }
      this.selectedFile.value = '';
    },
    cropGetRatio: function cropGetRatio() {
      var ih = this.img.naturalHeight;
      var canvas = document.createElement('canvas');
      canvas.width = 1;
      canvas.height = ih;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(this.img, 0, 0);
      var data = ctx.getImageData(0, 0, 1, ih).data;

      var sy = 0;
      var ey = ih;
      var py = ih;
      while (py > sy) {
        var alpha = data[(py - 1) * 4 + 3];
        if (alpha === 0) {
          ey = py;
        } else {
          sy = py;
        }
        py = ey + sy >> 1;
      }
      var ratio = py / ih;
      return ratio === 0 ? 1 : ratio;
    }
  }
});

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar-crop flex flex-column"
  }, [_c('div', {
    staticClass: "wrapper flex flex-1 flex-main-center flex-cross-center"
  }, [(_vm.defaultImage) ? _c('div', {
    staticClass: "image",
    style: ({
      'background-image': ("url('" + (_vm.croppedImage||_vm.defaultImage) + "')")
    })
  }) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "upload",
    attrs: {
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.fileChange
    }
  }), _vm._v(" "), (_vm.showCropDialog) ? _c('div', {
    staticClass: "crop flex flex-main-center flex-cross-center",
    attrs: {
      "transition": "crop"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dialog",
    style: ({
      width: _vm.width + 'px'
    })
  }, [_c('section', {
    class: {
      grab: !_vm.grabbing, grabbing: _vm.grabbing
    },
    style: ({
      height: _vm.height + 'px'
    })
  }, [(_vm.showCircle) ? _c('div', {
    staticClass: "img-circle"
  }) : _vm._e(), _vm._v(" "), _c('img', {
    style: ({
      width: _vm.scaleWidth + 'px',
      height: _vm.scaleHeight + 'px',
      left: _vm.scaleX + 'px',
      top: _vm.scaleY + 'px'
    }),
    attrs: {
      "src": _vm.img ? _vm.img.src : null
    },
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        _vm.cropDragBegin($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        _vm.cropDragMove($event)
      },
      "touchend": function($event) {
        $event.preventDefault();
        _vm.cropDragEnd($event)
      }
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "flex flex-main-center vux-1px-t"
  }, [_c('button', {
    staticClass: "btn flex-1 vux-1px-r",
    on: {
      "click": _vm.cropCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('button', {
    staticClass: "btn flex-1",
    on: {
      "click": _vm.cropOK
    }
  }, [_vm._v(_vm._s(_vm.okText))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scale),
      expression: "scale"
    }],
    staticClass: "scale",
    attrs: {
      "type": "range",
      "value": "100",
      "min": "100",
      "max": "200",
      "step": "1"
    },
    domProps: {
      "value": (_vm.scale)
    },
    on: {
      "input": _vm.cropZoom,
      "__r": function($event) {
        _vm.scale = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("点击更改头像")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "v-beat v-beat-odd"
  }), _vm._v(" "), _c('div', {
    staticClass: "v-beat v-beat-even"
  }), _vm._v(" "), _c('div', {
    staticClass: "v-beat v-beat-odd"
  })])
}]}

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column flex-1"
  }, [_c('u-header', {
    attrs: {
      "show-back": ""
    }
  }, [_vm._v("上传头像")]), _vm._v(" "), _c('div', {
    staticClass: "scrollable container flex-1 flex flex-column"
  }, [_c('avatar-crop', {
    attrs: {
      "default-image": _vm.currentAvatar,
      "show-circle": "",
      "return-base64": ""
    },
    on: {
      "change": _vm.onAvatarChange
    }
  }), _vm._v(" "), (_vm.btnVisible) ? [(_vm.percent > 0 && _vm.percent < 100) ? _c('u-progress', {
    attrs: {
      "percent": _vm.percent
    }
  }) : _vm._e(), _vm._v(" "), _c('u-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("上传")])] : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(241)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(249),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2648f1e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/6.c8cc2575b986ff70aa8f.js